import React from "react";

import { IUser } from "Auth/types";
import { ErrorBoundary, Footer, FooterProps } from "shared/components";
import { GridLayout } from "shared/styles";
import { Navbar as VenuesNavbar } from "Venues/containers";
import { Navbar as BandsNavbar } from "Bands/containers";
import { isBandsDomain, isVenueDomain } from "shared/utils";
import { IEvent } from "Bands/types";
import { RelatedEventBanner } from "Bands/components";

export interface LayoutProps extends FooterProps {
  currentUser?: IUser;
  event?: IEvent | null;
}

export const Layout: React.FC<LayoutProps> = ({
  event,
  handleOpenCookies,
  children,
  ...rest
}) => {
  return (
    <main>
      <GridLayout>
        <div style={{ gridArea: "nav" }}>
          {isVenueDomain && <VenuesNavbar {...rest} />}
          {isBandsDomain && <BandsNavbar {...rest} />}
          {event && <RelatedEventBanner event={event} />}
        </div>
        <ErrorBoundary>{children}</ErrorBoundary>
        <Footer handleOpenCookies={handleOpenCookies} />
      </GridLayout>
    </main>
  );
};
